import React from "react";
import PageLayout from "../../../layouts/application/Page/Layout";
import Content from "../../../components/molecules/PageNotFound";

const PageNotFound = () => {
  return (
    <PageLayout route="">
      <Content />
    </PageLayout>
  );
};

export default PageNotFound;
